import type { TTexture } from '@seddi/surface-material';

export type TextureDesc = TTexture & {
  imageBitmap?: ImageBitmap;
};

// List of texture keys from MeshPhysicalMaterial (and inherited from MeshStandardMaterial)
export const textureMapsKeys = [
  'map',
  'alphaMap',
  'aoMap',
  'bumpMap',
  'emissiveMap',
  'envMap',
  'lightMap',
  'metalnessMap',
  'normalMap',
  'roughnessMap',
  'anisotropyMap',
  'clearcoatMap',
  'clearcoatNormalMap',
  'clearcoatRoughnessMap',
  'iridescenceMap',
  'iridescenceThicknessMap',
  'sheenRoughnessMap',
  'sheenColorMap',
  'specularIntensityMap',
  'specularColorMap',
  'thicknessMap',
  'transmissionMap',
  'heightMap',
];
